import { Theme } from "@emotion/react";
import { Colors } from "./colors";

export const light: Theme = {
  viewBackground: Colors.WHITE,
  viewLoginBackground: Colors.BLUE,
};
